var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-buttons"},[_c('v-row',_vm._l((_vm.buttons),function(btn,index){return _c('v-col',{key:index,attrs:{"md":btn.width,"sm":btn.widthSm || null}},[_c('a',{attrs:{"href":btn.href}},[_c('v-img',{attrs:{"src":btn.image}})],1)])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }